module.exports = __webpack_public_path__ + "img/jft_down_logo.d26ab487.png";